module.exports = __webpack_public_path__ + "img/close.adc83e1e.svg";